import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { clientPortalUsersReportQueryOptions } from '~bank-reports/service/clientPortalUsersReportQueryOptions'
import { ClientPortalUsersActivityReportResponse } from '~bank-reports/types/ClientPortalUsersActivityReport'

import { ClientPortalUsersActivityReportContext } from './reportContext'

export const ClientPortalReportContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const routeApi = getRouteApi('/_app/reports/client')
  const search = routeApi.useSearch()

  const { data, isFetching } = useQuery<ClientPortalUsersActivityReportResponse>(
    clientPortalUsersReportQueryOptions(search)
  )

  if (!data) return null

  return (
    <ClientPortalUsersActivityReportContext.Provider value={{ data, isFetching, routeApi }}>
      {children}
    </ClientPortalUsersActivityReportContext.Provider>
  )
}
